<app-patient-setup-popup #patientPopup></app-patient-setup-popup>

<div class="page-container search-page-container">

  <div class="patients-page search-page row justify-center nowrap gap-50">

    <!-- Search Section -->
    <div class="search-section column gap-30 align-center w-100">

      <!-- Search Input Section -->
      <div class="column gap-10 w-100">
        <div class="title row align-center gap-20">
          <svg width="25" height="50" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z" stroke="#004D8B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M21 20.9999L16.65 16.6499" stroke="#004D8B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <h3>Quick Search</h3>
        </div>
        <div class="form-group">
          <input type="text" [(ngModel)]="filterString" (input)="applyFilter()" class="input-control" placeholder="Enter Name / Surname / ID / Cell phone" style="height: 45px;" />
          <svg width="25" height="50" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="PatientSearch()" class="position-absolute search-btn">
            <path d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z" stroke="#5F6366" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z" stroke="black" stroke-opacity="0.2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z" stroke="black" stroke-opacity="0.2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z" stroke="black" stroke-opacity="0.2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M21 20.9999L16.65 16.6499" stroke="#5F6366" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M21 20.9999L16.65 16.6499" stroke="black" stroke-opacity="0.2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M21 20.9999L16.65 16.6499" stroke="black" stroke-opacity="0.2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M21 20.9999L16.65 16.6499" stroke="black" stroke-opacity="0.2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
      </div>

      <!-- Filter Title -->
      <div class="title row align-center gap-20 w-100">
        <svg width="25" height="50" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.5557 21.0313C11.1946 21.1705 10.7946 21.1705 10.4335 21.0313C7.61621 19.9495 5.19326 18.0388 3.48475 15.5511C1.77623 13.0635 0.862555 10.1161 0.864383 7.09824V2.42276C0.864383 2.00942 1.02858 1.613 1.32085 1.32073C1.61314 1.02846 2.00954 0.864258 2.42288 0.864258H19.5663C19.9796 0.864258 20.3761 1.02846 20.6684 1.32073C20.9607 1.613 21.1249 2.00942 21.1249 2.42276V7.09824C21.1266 10.1161 20.213 13.0635 18.5045 15.5511C16.7959 18.0388 14.373 19.9495 11.5557 21.0313Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M15.7143 6.28564L9.42862 13.3571L6.28577 10.9999" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <h3>Patients by Status</h3>
      </div>

      <!-- Filter Lists -->
      <div class="column gap-20 justify-center align-center">

        <!-- Filter Options -->
        <div class="filter-options column">
          <ul class="row justify-center">
            <li class="gap-10">
              <label for="pageSize20" class="checkbox-control">
                20 entries
                <input type="radio" id="pageSize20" name="pageSize" [(ngModel)]="pageSize" value="20" checked="checked" [checked]="true" />
                <span class="checkbox-indicator"></span>
                <span class="checkbox-indicator-container"></span>
              </label>
            </li>
            <li class="gap-10">
              <label for="pageSize50" class="checkbox-control">
                50 entries
                <input type="radio" id="pageSize50" name="pageSize" [(ngModel)]="pageSize" value="50" />
                <span class="checkbox-indicator"></span>
                <span class="checkbox-indicator-container"></span>
              </label>
            </li>
            <li class="gap-10">
              <label for="pageSize100" class="checkbox-control">
                100 entries
                <input type="radio" id="pageSize100" name="pageSize" [(ngModel)]="pageSize" value="100" />
                <span class="checkbox-indicator"></span>
                <span class="checkbox-indicator-container"></span>
              </label>
            </li>
            <li class="gap-10">
              <label for="pageSizeAll" class="checkbox-control">
                All entries
                <input type="radio" id="pageSizeAll" name="pageSize" [(ngModel)]="pageSize" value="null" />
                <span class="checkbox-indicator"></span>
                <span class="checkbox-indicator-container"></span>
              </label>
            </li>
            <li class="gap-10">
              <label for="20-entries" class="checkbox-control">
                Inactive
                <input type="checkbox" id="20-entries" [(ngModel)]="includeInactive" />
                <span class="checkbox-indicator"></span>
                <span class="checkbox-indicator-container"></span>
              </label>
            </li>
          </ul>
        </div>
        <!-- Filter Results -->
        <div class="nowrap column gap-20 align-center">
          <div class="row gap-20 justify-between">
            <div class="list-card">
              <div class="list-card-header">
                <h2>New Patients</h2>
              </div>
              <ul class="list-card-body" style=" min-width: 250px;">
                <li class="list-card-item" *ngFor="let patient of pagedNewPatients">
                  <label for="{{patient.Guid}}" class="checkbox-control">
                    {{patient.FullName}}
                    <input [(ngModel)]="patient.Selected" (change)="SelectPatient(patient)" type="checkbox" id="{{patient.Guid}}" />
                    <span class="checkbox-indicator"></span>
                    <span class="checkbox-indicator-container"></span>
                  </label>
                </li>
              </ul>
              <app-pagination [items]="filteredNewPatients"
                              [itemsPerPage]="10"
                              (pageItems)="updatePaginatedNewPatients($event)">
              </app-pagination>
            </div>
            <!--<div class="list-card">
              <div class="list-card-header">
                <h2>In Progress</h2>
              </div>
              <ul class="list-card-body">
                <li class="list-card-item" *ngFor="let patient of pagedProgressPatients">
                  <label for="{{patient.Guid}}" class="checkbox-control">
                    {{patient.FullName}}
                    <input [(ngModel)]="patient.Selected" (change)="SelectPatient(patient)" type="checkbox" id="{{patient.Guid}}" />
                    <span class="checkbox-indicator"></span>
                    <span class="checkbox-indicator-container"></span>
                  </label>
                </li>
              </ul>
              <app-pagination [items]="filteredProgressPatients"
                              [itemsPerPage]="10"
                              (pageItems)="updatePaginatedProgressPatients($event)">
              </app-pagination>
            </div>-->
            <div class="list-card">
              <div class="list-card-header">
                <h2>Old Patients</h2>
              </div>
              <ul class="list-card-body" style=" min-width: 250px;">
                <li class="list-card-item" *ngFor="let patient of pagedOldPatients">
                  <label for="{{patient.Guid}}" class="checkbox-control">
                    {{patient.FullName}}
                    <input [(ngModel)]="patient.Selected" (change)="SelectPatient(patient)" type="checkbox" id="{{patient.Guid}}" />
                    <span class="checkbox-indicator"></span>
                    <span class="checkbox-indicator-container"></span>
                  </label>
                </li>
              </ul>
              <app-pagination [items]="filteredOldPatients"
                              [itemsPerPage]="10"
                              (pageItems)="updatePaginatedOldPatients($event)">
              </app-pagination>
            </div>
          </div>
        </div>
      </div>


    </div>
    <!-- Search Section End -->

    <!-- Setup Section -->
    <div class="setup-options-form column gap-20 w-100">
      <div class="column">
        <div class="selected-setup-item row justify-space-between gap-20" *ngIf="selectedPatient && selectedPatient.Guid">
          <div class="title" style="text-wrap: nowrap;">
            <h3>{{selectedPatient.Title}} {{selectedPatient.FullName}}</h3>
          </div>
          <div class="column gap-20" style="width: auto;">
            <button type="button" class="custom-btn" (click)="View(selectedPatient)">View</button>
            <button type="button" class="custom-btn" (click)="Edit(selectedPatient)">Edit</button>
            <button type="button" class="custom-btn" (click)="Delete(selectedPatient)">Remove</button>
          </div>
          <!--<hr *ngIf="selectedProducts.length > 1" />-->
        </div>
      </div>
      <hr />
      <div class="column">
        <div class="row justify-space-between align-center gap-30">
          <div class="title align-center">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 0.642822V17.3571" stroke="#004D8B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M0.642883 8.94849H17.3572" stroke="#004D8B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <h3>New Patient</h3>
          </div>
          <button type="button" class="custom-btn" (click)="Add()">New</button>
        </div>
      </div>
      <hr />
      <div class="service-reports column gap-20">
        <div class="reports-section-header row align-center justify-space-between">
          <div class="title align-center">
            <svg width="25" height="50" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.3571 0.785767H8.64284C7.77497 0.785767 7.07141 1.48932 7.07141 2.3572V3.14291C7.07141 4.01078 7.77497 4.71434 8.64284 4.71434H13.3571C14.225 4.71434 14.9286 4.01078 14.9286 3.14291V2.3572C14.9286 1.48932 14.225 0.785767 13.3571 0.785767Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M15.3214 2.35718H17.6786C18.0953 2.35718 18.4951 2.52274 18.7897 2.81743C19.0844 3.11214 19.25 3.51183 19.25 3.92861V19.6429C19.25 20.0596 19.0844 20.4594 18.7897 20.7541C18.4951 21.0487 18.0953 21.2143 17.6786 21.2143H4.32143C3.90465 21.2143 3.50496 21.0487 3.21026 20.7541C2.91557 20.4594 2.75 20.0596 2.75 19.6429V3.92861C2.75 3.51183 2.91557 3.11214 3.21026 2.81743C3.50496 2.52274 3.90465 2.35718 4.32143 2.35718H6.67857" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M7.85712 14.1429L10.2143 15.7143L14.9285 9.42859" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <h3>Reports</h3>
          </div>
          <button type="button" class="report-btn" (click)="onGenerateReport('Excel')">
            <svg width="25" height="50" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.28571 10.2144L11 14.9286L15.7143 10.2144" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M11 0.785767V14.9286" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M5.5 21.2144H16.5" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            Download
          </button>
        </div>

        <div class="report-options">
          <ul class="reports-list">
            <li class="w-100">
              <label for="AllPatients" class="checkbox-control">
                Full List of Patients
                <input type="radio" id="AllPatients" [(ngModel)]="reportParam" value="" />
                <span class="checkbox-indicator"></span>
                <span class="checkbox-indicator-container"></span>
              </label>
            </li>
            <li class="w-100">
              <label for="NewPatients" class="checkbox-control">
                New Patients
                <input type="radio" id="NewPatients" [(ngModel)]="reportParam" value="NEW PATIENT" />
                <span class="checkbox-indicator"></span>
                <span class="checkbox-indicator-container"></span>
              </label>
            </li>
            <!--<li class="w-100">
              <label for="InProgressPatients" class="checkbox-control">
                In Progress
                <input type="radio" id="InProgressPatients" [(ngModel)]="reportParam" value="InProgressPatients" />
                <span class="checkbox-indicator"></span>
                <span class="checkbox-indicator-container"></span>
              </label>
            </li>-->
            <li class="w-100">
              <label for="OldPatients" class="checkbox-control">
                Old Patient
                <input type="radio" id="OldPatients" [(ngModel)]="reportParam" value="OLD PATIENT" />
                <span class="checkbox-indicator"></span>
                <span class="checkbox-indicator-container"></span>
              </label>
            </li>
          </ul>
        </div>

      </div>
    </div>
    <!-- Setup Section End -->
  </div>
</div>
